/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import cloudinary from "cloudinary-core"

function SEO({
  description,
  lang,
  meta,
  keywords,
  pagetitle,
  title,
  ogtitle,
  ogdescription,
  ogimage,
  noindex,
}) {
  const metaTitle = title || pagetitle
  const metaOgTitle = ogtitle || title
  const metaDescription = description || ogdescription
  const metaOgDescription = ogdescription || description

  const metaImage = ogimage || process.env.OG_IMAGE_DEFAULT_URL

  const cl = new cloudinary.Cloudinary({
    cloud_name: process.env.CLOUDINARY_CLOUD_NAME,
    secure: true,
  })
  const metaOgImageUrl = cl.url(metaImage, {
    type: "fetch",
    crop: "fill",
    width: 1200,
    height: 630,
    quality: "auto",
    fetchFormat: "auto",
  })

  const metaTwitterImageUrl = cl.url(metaImage, {
    type: "fetch",
    crop: "fill",
    width: 1200,
    height: 675,
    quality: "auto",
    fetchFormat: "auto",
  })

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      meta={[
        {
          name: "description",
          content: metaDescription,
        },
        {
          property: "og:title",
          content: metaOgTitle,
        },
        {
          property: "og:description",
          content: metaOgDescription,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:image",
          content: metaOgImageUrl,
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:title",
          content: metaTitle,
        },
        {
          name: "twitter:description",
          content: metaDescription,
        },
        {
          name: "twitter:image",
          content: metaTwitterImageUrl,
        },
        {
          name: "robots",
          content: noindex === 0 ? "index" : "noindex",
        },
      ]
        .concat(
          keywords.length > 0
            ? {
                name: "keywords",
                content: keywords.join(`, `),
              }
            : []
        )
        .concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: "de",
  meta: [],
  keywords: [],
  description: "",
  noindex: 0,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

export default SEO
